import React from "react";
import {
  Box,
  Heading,
  Text,
  Input,
  Divider,
  Tooltip,
} from "@chakra-ui/react";

const SectionBox = ({ title, children }) => (
  <Box
    mt={6}
    p={4}
    border="2px solid"
    borderColor="gray.600"
    borderRadius="md"
    bg="white"
    boxShadow="md"
    textAlign="left"
  >
    <Heading size="md" mb={2}>{title}</Heading>
    <Divider mb={4} />
    {children}
  </Box>
);

const getBorderColor = (original, value) => {
  const hasOriginal = original !== undefined && original !== null && original !== "";
  const hasValue = value !== undefined && value !== null && value !== "";

  if (!hasOriginal && hasValue) return "2px solid green"; // Added
  if (hasOriginal && !hasValue) return "2px solid red";   // Deleted
  if (hasOriginal && hasValue && original !== value) return "2px solid blue"; // Changed
  return "1px solid #E2E8F0"; // Unchanged
};

const getTooltipLabel = (original, value) => {
  const hasOriginal = original !== undefined && original !== null && original !== "";
  const hasValue = value !== undefined && value !== null && value !== "";

  if (!hasOriginal && hasValue) return "Added new value";
  if (hasOriginal && !hasValue) return `Deleted previous value: ${original}`;
  if (hasOriginal && hasValue && original !== value) return `Changed from: ${original}`;
  return "";
};

const SalesSection = ({ salesRepresentative, setSalesRepresentative, originalData = {} }) => {
  const original = originalData.salesRepresentative;

  return (
    <SectionBox title="Sales Information (Optional)">
      <Text fontSize="sm" color="gray.600" mb={3}>
        If applicable, please provide the name of your CuraGenesis sales representative.
      </Text>
      <Box mb={3}>
        <Text fontSize="sm" mb={1}>Sales Representative Name</Text>
        <Tooltip
          label={getTooltipLabel(original, salesRepresentative)}
          isDisabled={!getTooltipLabel(original, salesRepresentative)}
        >
          <Input
            placeholder="Sales Representative"
            value={salesRepresentative || ""}
            onChange={(e) => setSalesRepresentative(e.target.value)}
            border={getBorderColor(original, salesRepresentative)}
          />
        </Tooltip>
      </Box>
    </SectionBox>
  );
};

export default SalesSection;
